import AsyncStorage from '@react-native-async-storage/async-storage';

/**
 * Auth storage for web platform.
 * Uses AsyncStorage (localStorage) since SecureStore is native-only.
 */
export const authStorage = {
  getItem: (key: string): Promise<string | null> => {
    return AsyncStorage.getItem(key);
  },

  setItem: async (key: string, value: string): Promise<void> => {
    await AsyncStorage.setItem(key, value);
  },

  deleteItem: async (key: string): Promise<void> => {
    await AsyncStorage.removeItem(key);
  },
};
